module.exports = __webpack_public_path__ + "img/pic_4.2a01728b.svg";